export default __webpack_public_path__ + "5c56943a3eb34a82fea53d95e03689ee.svg";